export const Toggle = () => {
    return <div className='toggle'></div>
}